define(function(require, exports, module) {
    var headFoot = require('./unit/headerFooter/headerFooter');
    var lazyload = require('./unit/lazyload/lazyload');
    var tapEvent = require('./unit/tapEvent/tapEvent');
    var goTop = require('./unit/goTop/goTop');
    var price = require('./unit/price/price');
    var bottomCatSwiper = require("./module/selfChannelBottomCatSwiper");


    headFoot.loadHeadAndFooter();
    price.fn.getPrice();
    tapEvent.tapItem();
    tapEvent.tapSale();
    tapEvent.tapLink();
    goTop.fn.init();
    bottomCatSwiper.init();
    lazyload.fn.init();
});



// WEBPACK FOOTER //
// ./src/js/selfchannel.js